module.exports = __webpack_public_path__ + "img/walk.b949d621.png";